import axios from "axios";

const api = axios.create({
  baseURL: "https://vhg.ar/flotapp/api/",
  //baseURL: "http://localhost:8000/api/",
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;